import { mapMutations } from 'vuex';
export default [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/landing/Home.vue'),
      meta: {
        title: 'WeChamber',
      },
    },
    {
      path: '/eventos',
      name: 'events',
      component: () => import('../views/landing/Events.vue'),
      meta: {
        title: 'Eventos',
      },
    },
    {
      path: '/afiliaciones',
      name: 'plans',
      component: () => import('../views/landing/Plans.vue'),
      meta: {
        title: 'Afiliaciones',
      },
    },
    {
      path: '/eventos/:id',
      name: 'event-detail',
      component: () => import('../views/landing/EventDetail.vue'),
      meta: {
        title: 'Eventos',
      },
    },
    // {
    //   path: '/eventos-test/:id',
    //   name: 'event-detail-test',
    //   component: () => import('../views/landing/EventDetailOld.vue'),
    //   meta: {
    //     title: 'Eventos',
    //   },
    // },
    {
      path: '/eventos-organizador/:id',
      name: 'organizer-event',
      component: () => import('../views/landing/OrganizerEvents.vue'),
      meta: {
        title: 'EventosOrganizador',
      },
    },
    {
      path: '/afiliaciones/:id',
      name: 'affiliation-detail',
      component: () => import('../views/landing/PlanDetail.vue'),
      meta: {
        title: 'Afiliaciones',
      },
    },
    // {
    //   path: '/afiliaciones-test/:id',
    //   name: 'affiliation-detail',
    //   component: () => import('../views/landing/PlanDetailOld.vue'),
    //   meta: {
    //     title: 'Afiliaciones',
    //   },
    // },
    {
      path: '/eventos/:id/checkout',
      name: 'checkout',
      component: () => import('../views/landing/checkout/Base.vue'),
      meta: {
        title: 'Adquirir boletos',
      },
    },
    {
      path: '/afiliaciones/:id/checkout',
      name: 'affiliation-checkout',
      component: () => import('../views/landing/checkout/Base.vue'),
      meta: {
        title: 'Adquirir afiliaciones',
      },
    },
    {
      path: '/como-funciona',
      name: 'how-it-works',
      component: () => import('../views/landing/HowItWorks.vue'),
      meta: {
        title: '¿Cómo funciona?',
      },
    },
    {
      path: '/nosotros',
      name: 'about-us',
      component: () => import('../views/landing/AboutUs.vue'),
      meta: {
        title: 'Nosotros',
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/landing/Login.vue'),
      meta: {
        title: 'Inicio de sesión',
      },
    },
    {
      path: '/recuperar-contraseña',
      name: 'password-recover',
      component: () => import('../views/landing/PasswordRecover.vue'),
      meta: {
        title: 'Recuperación de contraseña',
      },
    },
    {
      path: '/nueva-contraseña/:token',
      name: 'password-reset',
      component: () => import('../views/landing/PasswordReset.vue'),
      meta: {
        title: 'Nueva contraseña',
      },
    },
    {
      path: '/registro/:tipoUsuario',
      name: 'sign-in',
      component: () => import('../views/landing/SignIn.vue'),
      meta: {
        title: 'Registro',
      },
    },
    {
      path: '/registro-organizador-lite',
      name: 'sign-up-lite-organizer',
      component: () => import('../views/landing/SingUpLiteOrganizer.vue'),
      meta: {
        title: 'Registro lite'
      }
    },
    {
      path: '/aviso-de-privacidad',
      name: 'privacy',
      component: () => import('../views/landing/Privacy.vue'),
      meta: {
        title: 'Aviso de privacidad',
      },
    },
    {
      path: '/terminos-y-condiciones',
      name: 'terms',
      component: () => import('../views/landing/Terms.vue'),
      meta: {
        title: 'Términos y Condiciones de Servicio',
      },
    },
    {
      path: '/precios-y-comisiones',
      name: 'prices',
      component: () => import('../views/landing/Prices.vue')
    },
    {
      path: '/contacto',
      name: 'contact',
      component: () => import('../views/landing/ContactUs.vue'),
      meta: {
        title: 'Contacto',
      },
    },
    {
      path: '/solucionador-de-problemas',
      name: 'problem-solver',
      component: () => import('../views/landing/ProblemSolver.vue'),
      meta: {
        title: 'Solucionador de problemas',
      },
    },
    {
      path: '*',
      name: '404',
      component: () => import('../views/landing/State404.vue'),
      meta: {
        title: '¡Ooops!',
      },
    },
  ]